import React from "react";
import ReactApexChart from "react-apexcharts";

const Chart = () => {
  const [state, setState] = React.useState({
    series: [
      {
        data: [10, 14, 14, 12, 10, 8, 10, 6, 8, 8],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          barHeight: "50%",
          barOffset: 20,
        },
      },

      stroke: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const category = w.config.xaxis.categories[dataPointIndex];
          const value = series[seriesIndex][dataPointIndex];
          return `<div style="padding: 6px 10px; font-size: 12px;color:#000;">
        <strong>${category}</strong>: ${value}
      </div>`;
        },
      },
      xaxis: {
        min: 0,
        max: 14,
        tickAmount: 7,
        title: {
          text: "Percent",
          style: {
            color: "#fff",
            fontSize: "16px",
            fontWeight: 600,
          },
          offsetY: 10,
        },
        labels: {
          formatter: function (value) {
            return value; // 👈 remove % from each number
          },
          style: {
            colors: "#fff",
            fontSize: "12px",
            fontWeight: 500,
          },
        },
        categories: [
          "Staking Rewards",
          "Rewards from Diag",
          "Reserve Pool",
          "Pre-Sale Investors",
          "Management",
          "Marketing",
          "Community",
          "Airdrops and Bounty",
          "Advisors",
          "Partners",
        ],
        labels: {
          style: {
            colors: "#fff", // Red numbers
            fontSize: "12px",
            fontWeight: 500,
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#fff",
            fontSize: "14px",
            fontWeight: 500,
          },
        },
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },
      colors: ["#6E9DEC"],
    },
  });

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={state.options}
          series={state.series}
          type="bar"
          height={350}
        />
      </div>
    </div>
  );
};

export default Chart;
